import React, {useEffect} from 'react';
import NavbarSmallLight from "./navbar-small-light";
import Footer from "./footer";
import {useDispatch, useSelector} from "react-redux";
import {selectContactUsData, selectNavbarData} from "../store/selectors";
import {getContactUsData, getMetaData, getNavbarData} from "../store/actions/app";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
const removeLangPrefix = (pathname) => {
    const parts = pathname.split('/');
    if (['ru', 'hy', 'en'].includes(parts[1])) {
        return '/' + parts.slice(2).join('/');
    }
    return pathname;
};
function Wrapper(props) {

    const dispatch = useDispatch();
    const location = useLocation();
    const { i18n } = useTranslation();

    const navbarData = useSelector(selectNavbarData);
    const contactUsData = useSelector(selectContactUsData);
    const pagePath = removeLangPrefix(location.pathname || '/');

    const status = useSelector(state => state.app.status.navbarData);
    const statusContactUsData = useSelector(state => state.app.status.contactUsData);

    useEffect(() => {
        if (status === 'idle') dispatch(getNavbarData());
        if (status === 'idle') dispatch(getContactUsData());

        dispatch(getMetaData({ page: pagePath || '/' }));
    }, [dispatch, status, statusContactUsData, pagePath, i18n.language]);
    return (
        <div>
            <NavbarSmallLight navbarData={navbarData} />
                {props.children}
            <Footer contactUsData={contactUsData}  navbarData={navbarData} />
        </div>
);
}

export default Wrapper;